import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import store from "../../../../app/store";
import { API_STATUS } from "../../sliceUtil";
import { setLoaderFalse, setLoaderTrue } from "../../../../Redux/loaderSlice";
import { HttpStatusCode } from "axios";
import { CustomError } from "../../../../api/CustomError";
import { CustomSuccess } from "../../../../api/CustomSuccess";
import { _get, _post } from "../../../../api/apiClient";

const initEmailTemplatesState = {
  externalDepositRecords: null,
  isLoading: API_STATUS.STATUS_IDLE,
  totalRequestedDeposit: 0,
};

const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId;
};

export const fetchExternalDepositRecords = createAsyncThunk(
  "/fetchExternalDepositRecords",
  async ({ paginationObj, disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Fetched External Deposit Records successfully.",
        errorMessage: "Failed to fetch External Deposit Records!",
      };

      const _pageNumber = paginationObj?.currentPage
        ? `PageNumber=${paginationObj?.currentPage}`
        : "";
      const _pageSize =
        paginationObj?.limit > 0 ? `&PageSize=${paginationObj?.limit}` : "";

      const response = await _get(
        `bank/${_orgClientId()}/externaldeposit/list?${_pageNumber}${_pageSize}`,
      );

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      const {
        data: externalDepositRecords,
        error,
        message,
        status,
        statusCode,
        responseType,
      } = CustomSuccess(response, {
        ...config,
        disableToast: true,
      });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        externalDepositRecords,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const fetchSumOfExternalDeposits = createAsyncThunk(
  "/fetchSumOfExternalDeposits",
  async ({ disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Sum Of External Deposits successfully.",
        errorMessage: "Failed to Sum Of External Deposits!",
      };

      const response = await _get(`bank/${_orgClientId()}/externaldeposit`);

      if (response?.data?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      const {
        data: sumOfExternalDeposits,
        error,
        message,
        status,
        statusCode,
        responseType,
      } = CustomSuccess(response, {
        ...config,
        disableToast: true,
      });
      thunkAPI.dispatch(setLoaderFalse());
      return {
        sumOfExternalDeposits,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (error) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const addRequestedExternalDeposit = createAsyncThunk(
  "addRequestedExternalDeposit",
  async ({ depositObj, disableLoader }, thunkAPI) => {
    try {
      if (!disableLoader) thunkAPI.dispatch(setLoaderTrue());
      const config = {
        successMessage: "Deposit Added Successfully.",
        errorMessage: "Failed to add deposit!",
      };

      const response = await _post(`bank/${_orgClientId()}/externaldeposit`, depositObj);

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      const _response = CustomSuccess(response, {
        ...config,
      });
      thunkAPI.dispatch(setLoaderFalse());
      return _response;
    } catch (err) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const externalDepositSlice = createSlice({
  name: "externalDeposit",
  initialState: initEmailTemplatesState,
  reducers: {
    setTemplateId: (_state, action) => {
      _state.templateId = action.payload;
    },
    resetTemplateId: (_state) => {
      _state.templateId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExternalDepositRecords.pending, () => ({
        isLoading: API_STATUS.STATUS_LOADING,
      }))
      .addCase(fetchExternalDepositRecords.fulfilled, (_state, action) => ({
        isLoading: API_STATUS.STATUS_SUCCESS,
        externalDepositRecords: action?.payload?.emailTemplates?.templates,
        // totalEmailTemplates: action?.payload?.emailTemplates?.totalCount,
      }))
      .addCase(fetchExternalDepositRecords.rejected, (_state, action) => {
        return {
          isLoading: API_STATUS.STATUS_FAILURE,
          message:
            action.error.message ||
            "Error while fetching externalDepositRecords",
          externalDepositRecords: [],
        };
      });
  },
});

export const {} = externalDepositSlice.actions;
